import PlayerManager from "./player";
import EnemyManager from "./enemies";
class EntityManager {
    player;
    enemies;
    static instance;
    /**
     * EntityManager holds all the entities in the game.
     * @param scene the rendering scene.
     * @param physicsWorld the physics world.
     * @private
     */
    constructor(scene, physicsWorld) {
        this.player = PlayerManager.getInstance(scene, physicsWorld);
        this.enemies = EnemyManager.getInstance(scene, physicsWorld);
    }
    /**
     * Call the step methods of all the entities and managers.
     * @param scene the rendering scene.
     * @param physicsWorld the physics world.
     * @param terrain The terrain, used for checks when shooting.
     * @param deltaTime The interval in seconds from the last frame to the current one.
     */
    step(scene, physicsWorld, terrain, deltaTime) {
        this.player.step(this.enemies.getEnemies, terrain, deltaTime);
        this.enemies.step(scene, physicsWorld, [this.player.getPlayer], terrain, deltaTime);
    }
    get getPlayer() {
        return this.player.getPlayer;
    }
    /**
     * Get or create an entity manager.
     * @param scene the rendering scene.
     * @param physicsWorld the physics world.
     * @returns An instance of an entity manager.
     */
    static getInstance(scene, physicsWorld) {
        if (!EntityManager.instance)
            EntityManager.instance = new EntityManager(scene, physicsWorld);
        return EntityManager.instance;
    }
}
export default EntityManager;
